var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"138","height":"138","viewBox":"0 0 138 138"}})
}
var staticRenderFns = []

export { render, staticRenderFns }